<button mat-button class="btn" type="button" (click)="exportexcel()" *ngIf="exportExcel">Descargar excel</button>
<div class="mat-elevation-z8" #excelTable>
  <table mat-table [dataSource]="dataSource" DisableClear Direction="desc">
    <ng-container [ngSwitch]="column.type" *ngFor="let column of displayedColumns; let i = index">
      <ng-container *ngSwitchDefault [matColumnDef]="column.attr">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{column.label}}</th>
        <td mat-cell *matCellDef="let row">{{ row[column.attr]}}</td>
      </ng-container>
      <ng-container *ngSwitchCase="'Link'" [matColumnDef]="column.attr">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{column.label}}</th>
        <td mat-cell *matCellDef="let row">
          <a class="link" [routerLink]="column.attr.replace('${ID}', row._id)">{{column.label}}</a>
        </td>
      </ng-container>
      <ng-container *ngSwitchCase="'DobleObject'" [matColumnDef]="column.attr">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{column.label}}</th>
        <td mat-cell *matCellDef="let row">{{ row[column.attr][column.attrSecond]}}</td>
      </ng-container>
      <ng-container *ngSwitchCase="'Date'" [matColumnDef]="column.attr">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{column.label}}</th>
        <td mat-cell *matCellDef="let row">{{ row[column.attr] | date}}</td>
      </ng-container>
      <ng-container *ngSwitchCase="'Select'" [matColumnDef]="column.attr">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{column.label}}</th>
        <td mat-cell *matCellDef="let row">
          <a class="link" (click)="selectItem(row[column.attr])">{{column.label}}</a>
        </td>
      </ng-container>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="objectColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: objectColumns;"></tr>
  </table>
  <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Select page of users"></mat-paginator>
</div>
